import "./styles.css";

const currentYear = new Date().getFullYear().toString();

for (const node of document.querySelectorAll<HTMLElement>("[data-current-year]")) {
  node.textContent = currentYear;
}
